/* eslint-disable no-unused-vars */
import React, { useContext, useState, useCallback } from 'react';
import './style.scss';

import { LoadGif } from '../LoadGif';
import {
  getAprovacaoAnexo,
  getAprovacoes,
  getFiltrosAprovacoes,
  GetProcesso,
  isValid,
  LogGetProcesso,
  submitAprovacao,
} from 'src/services/auth';

import { LogContext } from '../LogProvider';
import { useEffect } from 'react';

import { ReactComponent as Accept } from 'src/assets/icons/accept.svg';
import { ReactComponent as Reject } from 'src/assets/icons/reject.svg';
import { ReactComponent as Clip } from 'src/assets/icons/clip.svg';
import { ReactComponent as Reload } from 'src/assets/icons/reload.svg';
import { ReactComponent as Upload } from 'src/assets/icons/upload.svg';

import ExtensionIcon from '../ExtensionIcon';
import { newTab } from 'src/pages/home';
import { RenderPdf } from '../renderPdf';

const proxyUrl = window.globalConfig.PROXY_URL;

export default function Aprovacoes() {
  const { setLogData, setLoadIndex } = useContext(LogContext);

  const [load, setLoad] = useState(false);
  const user = JSON.parse(localStorage.getItem('userDetails'));
  const url = `${proxyUrl}/${localStorage.getItem('url')?.replace('_gestao', '')}`;

  const [approvalsList, setApprovalsList] = useState([]);
  const [filterApprovalList, setFilterApprovalList] = useState([]);

  const [showPopup, setShowPopup] = useState('');
  const [selectApproval, setSelectApproval] = useState();
  const [respondedApprovals, setRespondedApprovals] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [search, setSearch] = useState('');
  const [filtros, setFiltros] = useState([]);
  const [filtro, setFiltro] = useState(0);

  function timedLoad(time) {
    setLoad(true);
    setTimeout(() => {
      setLoad(false);
    }, time);
  }

  function fetchApprovals() {
    setRespondedApprovals([]);
    setLoad(true);
    setApprovalsList([]);

    const idEmp = localStorage.getItem('idEmp');
    const data = {
      codemp: idEmp,
      solApr: 1,
      rotNap: 99,
    };

    GetProcesso('GetAprovacao', data, true, false)
      .then((approvals) => {
        const aprovacoes = !Array.isArray(approvals?.retorno)
          ? [approvals.retorno]
          : approvals?.retorno || [];

        setApprovalsList(aprovacoes);
      })
      .finally(() => setLoad(false));
  }

  const submitApprovals = useCallback(async () => {
    setLoad(true);
    try {
      const dataTest = {
        envio: {
          strChv: '${aprovacao.strChv}',
          rotNap: '${aprovacao.rotNap}',
          codEmp: '${aprovacao.codEmp}',
          aprNap: "${aprovacao.response === 'A' ? 'S' : 'N'}",
        },
      };

      const data = {};
      respondedApprovals.forEach((item, index) => {
        data[`data(${index})`] = {
          codEmp: item.codEmp,
          rotNap: item.rotNap,
          strChv: item.strChv,
          aprNap: item.aprNap,
        };
      });

      await GetProcesso('SetAprovacao', data, true, false);
      setRespondedApprovals([]);
    } catch (error) {
      setErrorMessage(
        error.message || 'Ocorreu um erro ao enviar as aprovações'
      );
    }
    setLoad(false);
    fetchApprovals();
  }, [respondedApprovals, fetchApprovals, url]);

  useEffect(() => {
    fetchApprovals();

    if (filtros.length <= 0) {
      const idEmp = localStorage.getItem('idEmp');
      const data = {
        arqJso: `{"Dados":{"codemp":"${idEmp}","tipoProcesso":"acaoConsultaRotina","tipoAcao":"C"}}`,
        texJso: '',
      };

      GetProcesso('GetMovimento', data, false, false)
        .then((response) => {
          const parsedResponse = JSON.parse(response.arqJso);
          const formatRes = parsedResponse.Dados.map((categoria) => ({
            label: categoria.desnap,
            value: categoria.rotnap,
          }));

          setFiltros(formatRes);
        })
        .catch((error) => {
          console.error('Erro ao buscar filtros:', error);
        });
    }
  }, []);

  useEffect(() => {
    setFilterApprovalList(
      search.length > 0
        ? approvalsList.filter((item) =>
            item?.titApr.toLowerCase().includes(search.toLowerCase())
          )
        : approvalsList
    );
  }, [approvalsList, search]);

  const highlightSearch = (name) => {
    if (!search) return name;

    const parts = name.split(new RegExp(`(${search})`, 'gi'));
    return parts?.map((part, idx) =>
      part.toLowerCase() === search.toLowerCase() ? (
        <strong key={idx}>{part}</strong>
      ) : (
        part
      )
    );
  };

  return (
    <div className="Aprovacoes">
      {load && <LoadGif />}

      <div className="hotbar">
        <div className="baseInput select">
          <select onChange={(e) => setFiltro(e.target.value)}>
            <option value={0}>Categorias</option>
            {filtros.length > 0 &&
              filtros?.map((item, index) => {
                return (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                );
              })}
          </select>
        </div>
        <input
          type="text"
          placeholder="Buscar por título"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <button onClick={submitApprovals} className="mainButton yellow upload">
          <Upload />
          Enviar
          {respondedApprovals.length > 0 && (
            <span>{respondedApprovals.length}</span>
          )}
        </button>
        <button
          onClick={() => {
            fetchApprovals();
            timedLoad(1000);
          }}
          className="mainButton turquoise reload"
        >
          <Reload />
        </button>
      </div>
      <div className="listaAprov">
        {(showPopup !== '' || load) && (
          <button
            onClick={() => {
              setShowPopup('');
            }}
            className="fade"
          />
        )}

        {showPopup === 'anexos' && !load && (
          <div className="modal modalAprov absoluteCenter mainShadow anexosPopup">
            <h6>Anexos:</h6>
            {!load &&
              (Array.isArray(selectApproval?.anexo)
                ? selectApproval.anexo
                : [selectApproval?.anexo]
              )
                .filter((file) => file)
                ?.map((file, i) => (
                  <button
                    key={i}
                    onClick={async () => {
                      setLoad(true);
                      try {
                        const data = {
                          codEmp: selectApproval.codEmp,
                          nomAnx: file.nomAnx,
                          seqAnx: file.seqAnx,
                          msgApr: selectApproval.msgApr,
                          numAnx: selectApproval.numAnx,
                          rotAnx: selectApproval.rotAnx,
                          rotNap: selectApproval.rotNap,
                          strChv: selectApproval.strChv,
                        };

                        const res = await GetProcesso(
                          'GetAnexo',
                          data,
                          false,
                          false
                        );
                        if (file.nomAnx.toLowerCase().endsWith('.pdf')) {
                          newTab(
                            file.nomAnx,
                            <RenderPdf data={res.retorno.arqAnx} />
                          );
                        } else {
                          const blob = new Blob([
                            Uint8Array.from(atob(res.retorno.arqAnx), (c) =>
                              c.charCodeAt(0)
                            ),
                          ]);
                          const url = URL.createObjectURL(blob);
                          window.open(url, '_blank');
                        }
                      } catch (err) {
                        alert(err.message);
                      } finally {
                        setLoad(false);
                        setShowPopup('');
                      }
                    }}
                  >
                    <ExtensionIcon extension={file.nomAnx} />
                    <span>{file.nomAnx}</span>
                  </button>
                ))}

            <button className="mainButton red" onClick={() => setShowPopup('')}>
              Fechar
            </button>
          </div>
        )}

        {filterApprovalList?.map((item, index) => {
          const toggleApproval = (responseType) => {
            const existing = respondedApprovals.find(
              (a) => a.strChv === item.strChv
            );

            if (existing?.response === responseType) {
              setRespondedApprovals((prev) =>
                prev.filter((a) => a.strChv !== item.strChv)
              );
            } else {
              setRespondedApprovals((prev) => [
                ...prev.filter((a) => a.strChv !== item.strChv),
                { ...item, response: responseType, aprNap: responseType },
              ]);
            }
          };

          if (
            Number(filtro) === 0 ||
            !isValid(filtro) ||
            item.rotNap === filtro
          )
            return (
              <div className="item mainShadow" key={index}>
                <p style={{ whiteSpace: 'pre-line' }}>
                  {highlightSearch(item?.titApr?.replace(/<br\s*\/?>/gi, '\n'))}
                </p>
                <div className="controls">
                  <button
                    onClick={() => toggleApproval('A')}
                    className={`mainButton turquoise ${respondedApprovals.find((a) => a?.strChv === item?.strChv)?.response === 'A' ? 'active' : ''}`}
                  >
                    <Accept />
                  </button>
                  <button
                    onClick={() => toggleApproval('R')}
                    className={`mainButton red ${respondedApprovals.find((a) => a?.strChv === item?.strChv)?.response === 'R' ? 'active' : ''}`}
                  >
                    <Reject />
                  </button>
                  {isValid(item?.anexo) && (
                    <button
                      onClick={() => {
                        setShowPopup('anexos');
                        setSelectApproval(item);
                      }}
                      className="mainButton turquoise anexos"
                    >
                      Anexos
                      <Clip />
                    </button>
                  )}
                </div>
              </div>
            );
        })}
      </div>
    </div>
  );
}
